import React from 'react'
import { useConversationBanner } from './hooks/useConversationBanner';
import { Alert } from '@material-ui/lab';
import { MeetingIcon } from '../Icons/MeetingIcon';
import { IconButton, Typography } from '@material-ui/core';
import { Button } from "@workboard/wobo-ui"
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';


const AlertEl = styled(Alert)`
  align-items: center;
`

const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`

const IconWrapper = styled.span`
  svg path {
    fill: #C25700;
  }
`

const ActionButton = styled(Button)`
  background-color: transparent;
`;

const BoldEl = styled(({ children, ...props }) =>
  <Typography variant="body1" component="span" {...props}>{children}</Typography>
)`
  font-family: "Lato","Helvetica Neue",Arial,Helvetica,sans-serif;
  font-weight: bold;
  font-size: 14px;
  font-style: normal;
`

/**
 * Format due date string
 * @param dueDate date string in YYYY/MM/DD format
 * @returns MMM DD formatted date string
 * @example formatDueDate('2021-09-30') // Sep 30th
 */
const formatDueDate = (dueDate: string) => {
  const date = new Date(dueDate);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export const ConversationBanner = () => {
  const { t } = useTranslation();
  const { item, isLoading, shouldDisplay, handleClose } = useConversationBanner();
  const { name, dueDate } = item || {}

  if (isLoading || !shouldDisplay) {
    return null;
  }

  const onClick = () => {
    window.wb_track("conversation_event", {
      eventType: "View",
      location: "my_conversations",
    });
  }

  const myConversationButton = (
    <ActionButton variant="secondary" size="small" href="/wb/conversations" rel="noopener noreferrer" onClick={onClick}>
      {t('My Check-Ins')}
    </ActionButton>
  )
  const closeButton = (
    <IconButton size='small' onClick={handleClose}>
      <CloseIcon />
    </IconButton>
  )
  const action = <ActionContainer>
    {myConversationButton}
    {closeButton}
  </ActionContainer>

  return (
    <AlertEl severity="warning" icon={<IconWrapper><MeetingIcon /></IconWrapper>} action={action}>
      <Trans
        i18nKey="checkIn.scheduleReminder"
        components={{
          BoldEl: <BoldEl />
        }}
        values={{ 
          name, 
          dueDate: formatDueDate(dueDate) 
        }}
      />
    </AlertEl>
  )
}
